import { queryClient } from "@clients/react-query";
import { BusinessCode } from "@localtypes/generated-gql";
import { QueryClientProvider } from "@tanstack/react-query";
import { DEFAULT_THEME, ThemeProvider } from "@zendeskgarden/react-theming";
import { Router } from "./Router";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

import "@zendeskgarden/css-bedrock/dist/index.css";

export const businessCodeToBrandIdMap: Record<BusinessCode, string> = {
    [BusinessCode.Gat]: import.meta.env.VITE_GAT_BRAND_ID,
    [BusinessCode.Ub]: import.meta.env.VITE_UB_BRAND_ID,
    [BusinessCode.Adv]: import.meta.env.VITE_ADV_BRAND_ID,
};

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={DEFAULT_THEME}>
                <Router />
            </ThemeProvider>
        </QueryClientProvider>
    );
}

export default App;
